import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { forkJoin } from 'rxjs';
import { City } from 'src/app/interfaces/api/city';
import { MDStock, Warehouse, Warehouses } from 'src/app/interfaces/api/product';
import { ProductService } from 'src/app/services/product.service';
import { SwiperContainer } from 'swiper/element';

@Component({
  selector: 'app-modal-select-stock-location',
  templateUrl: './modal-select-stock-location.component.html',
  styleUrls: ['./modal-select-stock-location.component.scss'],
})
export class ModalSelectStockLocationComponent implements OnInit {
  @Input() initialWarehouse: MDStock;
  @Input() initialCity: City | undefined;
  @Input() availableCities: City[];
  @Input() stockWarehouse: MDStock[];
  @ViewChild('swiperVertical') swiperVertical: ElementRef<SwiperContainer>;
  isLoading = true;
  warehouseList: Warehouses;
  selectedCity: City;
  selectedCityWarehouses: Warehouse[];

  constructor(private modalController: ModalController, private productService: ProductService) {}

  ngOnInit() {
    this.loadData(null);
  }

  async loadData(event: any) {
    this.isLoading = true;

    const warehouseReq = this.productService.getWarehouseList();

    forkJoin([warehouseReq]).subscribe({
      next: async ([warehouseRes]) => {
        const warehouses = { ...warehouseRes.warehouses };

        for (const MdWarehouse of this.stockWarehouse) {
          const warehouseInCity = warehouses[MdWarehouse.city_name];

          if (!warehouseInCity) {
            continue;
          }

          const selectedCity = [...warehouseInCity];
          const selectedWarehouseIndex = selectedCity.findIndex(item => item.name === MdWarehouse.warehouse_name);
          const selectedWarehouse = selectedCity[selectedWarehouseIndex];

          // replace old data
          selectedCity.splice(selectedWarehouseIndex, 1);

          // create warehouse data with updated stock
          const newWarehouse: Warehouse = { stock: MdWarehouse.ready_stock, ...selectedWarehouse };

          // push new data
          selectedCity.push(newWarehouse);

          // update warehouselist on selected city
          warehouses[MdWarehouse.city_name] = selectedCity;
        }

        this.warehouseList = warehouses;
      },
      complete: () => {
        this.isLoading = false;
        if (this.initialCity !== undefined) {
          this.selectedCity = this.initialCity;
          this.selectedCityWarehouses = this.warehouseList[this.selectedCity.name];
        }
        event?.target?.complete();
      },
    });
  }

  resetCity() {
    this.selectedCity = undefined;
  }

  selectCity(city: City) {
    this.selectedCity = city;
    this.selectedCityWarehouses = this.warehouseList[this.selectedCity?.name];
  }

  nextSlide() {
    this.swiperVertical.nativeElement.swiper.slideNext();
  }

  prevSlide() {
    this.swiperVertical.nativeElement.swiper.slidePrev();
  }

  selectCabang(warehouse: Warehouse) {
    if (warehouse?.stock > 0) {
      this.modalController.dismiss({ selectedWarehouse: warehouse, selectedCity: this.selectedCity }, 'confirm');
      this.resetCity();
    }
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
    this.resetCity();
  }
}
